import { ContactUs } from '@components/Common/ContactUs';
import { CustomerSMSLogin } from '@components/Login/CustomerSMSLogin';
import { LoginCard } from '@components/Login/LoginCard';
import { t } from '@lingui/core/macro';
import { customerRoutes } from 'noddi-util';
import { useAuthContext } from 'noddi-web';
import { Navigate } from 'react-router-dom';

export const Login = () => {
  const { isLoggedIn } = useAuthContext();

  if (isLoggedIn) {
    return <Navigate replace to={customerRoutes.userSelection.getBasePath()} />;
  }

  return (
    <LoginCard title={t`Sign in`}>
      <CustomerSMSLogin />

      <ContactUs className='text-sm' customText={t`if you're having trouble signing in`} />
    </LoginCard>
  );
};
